export default "__VITE_ASSET__399f859a__"